import type { LandingTestimonialFields } from '@repo/api-contracts';
import { trpc } from '@/shared/api';

interface UseUpdateLandingTestimonialOptions {
  readonly onSuccess?: () => void;
}

/** 제목·본문·담당자만 바꾼다. 사진은 교체 훅이 따로 맡는다. */
export const useUpdateLandingTestimonial = ({
  onSuccess,
}: UseUpdateLandingTestimonialOptions = {}) => {
  const mutation = trpc.landing.updateTestimonial.useMutation({ onSuccess });

  /** 성공하면 true — 폼 모달을 닫는 데 쓴다. 실패 원인은 error 로 화면에 남는다. */
  const updateItem = async (id: string, fields: LandingTestimonialFields): Promise<boolean> => {
    try {
      await mutation.mutateAsync({ id, ...fields });
      return true;
    } catch {
      // 서버 거부 문구는 mutation.error 로 남아 모달에 보인다 — 여기서는 닫지 않을 신호만 준다.
      return false;
    }
  };

  return {
    updateItem,
    isPending: mutation.isPending,
    error: mutation.error?.message ?? null,
    /** 지난 서버 오류를 지운다 — 수정 모달을 새로 열 때 쓴다. */
    reset: () => mutation.reset(),
  };
};
